<soft-page [blockScrollY]="true" customClass="!p-0">
  <soft-page-header customClass="!p-1">
    <soft-filter-and-sort
      class="w-full"
      [explorer]="explorerAbteilungen"
      [filterConfig]="filterConfig"
      [sortConfig]="sortConfig"
      (input)="updateQueryParams($event)"
    >
    </soft-filter-and-sort>
  </soft-page-header>
  @if (filteredItems$ | async; as abteilungen) {
    @if (abteilungen.length > 0 || (loading$ | async) === false) {
      @if (viewMode() === 'grid') {
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 select-none pt-0.5"
        >
          @for (abteilung of explorerAbteilungen.result(); track abteilung.id) {
            <soft-abteilung-card
              [grid]="true"
              [abteilung]="abteilung"
              [routerLink]="['./abteilung', $safeNavigationMigration(abteilung?.abteilung?.id)]"
              [queryParamsHandling]="'preserve'"
            >
            </soft-abteilung-card>
          } @empty {
            <div
              class="text-sm italic text-center w-full flex items-center justify-center p-6 col-span-4"
            >
              Keine Abteilungen gefunden
            </div>
          }
        </div>
      } @else {
        <div class="flex flex-col gap-2 select-none pt-0.5">
          @for (abteilung of explorerAbteilungen.result(); track abteilung.id) {
            <soft-abteilung-card
              [grid]="false"
              [abteilung]="abteilung"
              [routerLink]="['./abteilung', $safeNavigationMigration(abteilung?.abteilung?.id)]"
              [queryParamsHandling]="'preserve'"
            >
            </soft-abteilung-card>
          } @empty {
            <div
              class="text-sm italic text-center w-full flex items-center justify-center p-6"
            >
              Keine Abteilungen gefunden
            </div>
          }
        </div>
      }
    }
  }
</soft-page>
<ng-template #actionBar>
  <soft-menu-bar-pill-switch
    [options]="[
      { label: 'Liste', value: 'list', icon: 'fa-list fa-regular' },
      { label: 'Kacheln', value: 'grid', icon: 'fa-regular fa-table-cells-large' },
    ]"
    [(value)]="viewMode"
    [responsive]="true"
    tooltip="Anzeige"
  ></soft-menu-bar-pill-switch>
</ng-template>

<ng-template #trailingActionBar>
  <soft-menu-bar-button
    [icon]="'fa-regular fa-refresh'"
    [label]="'Aktualisieren'"
    [tooltip]="'Aktualisieren'"
    (execute)="refresh()"
    [responsive]="true"
  ></soft-menu-bar-button>
</ng-template>
